export enum MESSAGES {
  phaseStatusUpdate = 'Timeline::ProjectPhase status change',
  toDoStatusUpdate = 'Timeline::ProjectPhaseTodo status change',
  phaseFinishDateUpdate = 'Timeline::ProjectPhase finish date change',
}

export type Update<T> = (state: T) => void;
